// src/pages/brand-collaborations-client-stories/components/CollaborationGallery.jsx
import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CollaborationGallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('authentic-moments');
  const [lightboxImage, setLightboxImage] = useState(null);

  const galleryCategories = [
    {
      id: 'authentic-moments',
      name: 'Authentic Moments',
      description: 'Capturing genuine interactions and unguarded moments',
      icon: 'Heart'
    },
    {
      id: 'polished-aesthetic',
      name: 'Polished Aesthetic',
      description: 'Maintaining corporate brand standards with cinematic quality',
      icon: 'Sparkles'
    },
    {
      id: 'executive-portraits',
      name: 'Executive Portraits',
      description: 'Professional leadership imagery for corporate communications',
      icon: 'User'
    },
    {
      id: 'event-documentation',
      name: 'Event Documentation',
      description: 'Comprehensive coverage of corporate milestones and gatherings',
      icon: 'Camera'
    }
  ];

  const galleryContent = {
    'authentic-moments': [
      {
        id: 1,
        image: 'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1600',
        title: 'Collaborative Brainstorming',
        description: 'Natural team dynamics during strategic planning sessions',
        client: 'Global Tech Corporation'
      },
      {
        id: 2,
        image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=2070&auto=format&fit=crop',
        title: 'Innovation Discussion',
        description: 'Candid moments of creative problem-solving',
        client: 'StartUp Accelerator'
      },
      {
        id: 3,
        image: 'https://images.pixabay.com/photo/2017/08/10/02/05/people-2619817_960_720.jpg',
        title: 'Team Celebration',
        description: 'Genuine reactions to project milestone achievements',
        client: 'Manufacturing Excellence'
      },
      {
        id: 4,
        image: 'https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1600',
        title: 'Mentorship Moment',
        description: 'Authentic leadership development interactions',
        client: 'Professional Services Group'
      },
      {
        id: 5,
        image: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=2070&auto=format&fit=crop',
        title: 'Cultural Integration',
        description: 'Cross-cultural team collaboration in action',
        client: 'International Corporation'
      },
      {
        id: 6,
        image: 'https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=1600',
        title: 'Innovation Process',
        description: 'Behind-the-scenes product development discussions',
        client: 'Technology Innovation Hub'
      }
    ],
    'polished-aesthetic': [
      {
        id: 7,
        image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=2069&auto=format&fit=crop',
        title: 'Corporate Headquarters',
        description: 'Architectural excellence with brand integration',
        client: 'Fortune 500 Technology'
      },
      {
        id: 8,
        image: 'https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=1600',
        title: 'Luxury Development',
        description: 'Premium property presentation with sophisticated styling',
        client: 'Platinum Properties'
      },
      {
        id: 9,
        image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=2073&auto=format&fit=crop',
        title: 'Executive Boardroom',
        description: 'Cinematic corporate environment with brand consistency',
        client: 'Global Business Forum'
      },
      {
        id: 10,
        image: 'https://images.pixabay.com/photo/2016/11/29/09/37/architecture-1868667_960_720.jpg',
        title: 'Modern Workspace',
        description: 'Contemporary office design with professional aesthetic',
        client: 'Innovation Center'
      },
      {
        id: 11,
        image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2070&auto=format&fit=crop',
        title: 'Manufacturing Excellence',
        description: 'Industrial environment with polished presentation',
        client: 'Advanced Manufacturing'
      },
      {
        id: 12,
        image: 'https://images.pexels.com/photos/3802510/pexels-photo-3802510.jpeg?auto=compress&cs=tinysrgb&w=1600',
        title: 'Product Showcase',
        description: 'Sophisticated product presentation with brand alignment',
        client: 'Automotive Innovation'
      }
    ],
    'executive-portraits': [
      {
        id: 13,
        image: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=1600',
        title: 'CEO Leadership Portrait',
        description: 'Confident executive presence with corporate backdrop',
        client: 'Technology Corporation'
      },
      {
        id: 14,
        image: 'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=1600',
        title: 'VP Marketing Portrait',
        description: 'Professional headshot with brand-aligned styling',
        client: 'Global Manufacturing'
      },
      {
        id: 15,
        image: 'https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=1600',
        title: 'Board Member Portrait',
        description: 'Distinguished executive with corporate environment',
        client: 'International Holdings'
      },
      {
        id: 16,
        image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=2070&auto=format&fit=crop',
        title: 'Founder Portrait',
        description: 'Entrepreneurial leadership with innovation backdrop',
        client: 'StartUp Success Story'
      },
      {
        id: 17,
        image: 'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1600',
        title: 'Director Portrait',
        description: 'Executive presence with architectural elements',
        client: 'Real Estate Leadership'
      },
      {
        id: 18,
        image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=800&auto=format&fit=crop',
        title: 'C-Suite Executive',
        description: 'Senior leadership with modern corporate setting',
        client: 'Fortune 500 Corporation'
      }
    ],
    'event-documentation': [
      {
        id: 19,
        image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2070&auto=format&fit=crop',
        title: 'Annual Conference',
        description: 'Comprehensive event coverage with multiple angles',
        client: 'Global Business Summit'
      },
      {
        id: 20,
        image: 'https://images.pexels.com/photos/1709003/pexels-photo-1709003.jpeg?auto=compress&cs=tinysrgb&w=1600',
        title: 'Award Ceremony',
        description: 'Prestigious recognition event with VIP attendees',
        client: 'Industry Excellence Awards'
      },
      {
        id: 21,
        image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?q=80&w=2070&auto=format&fit=crop',
        title: 'Product Launch Event',
        description: 'High-profile launch with media and stakeholder coverage',
        client: 'Technology Innovation'
      },
      {
        id: 22,
        image: 'https://images.pixabay.com/photo/2018/11/23/15/10/buildings-3834138_960_720.jpg',
        title: 'Corporate Gala',
        description: 'Elegant evening event with sophisticated documentation',
        client: 'Luxury Hospitality Group'
      },
      {
        id: 23,
        image: 'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=800',
        title: 'Board Meeting',
        description: 'Strategic planning session with executive presence',
        client: 'International Corporation'
      },
      {
        id: 24,
        image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069&auto=format&fit=crop',
        title: 'Innovation Showcase',
        description: 'Technology demonstration with interactive elements',
        client: 'Research & Development'
      }
    ]
  };

  const currentGallery = galleryContent[selectedCategory] || [];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-text-primary mb-6">
            Collaboration <span className="text-gradient-gold">Gallery</span>
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto leading-relaxed">
            Exclusive content showcasing our ability to capture authentic moments while maintaining 
            the polished aesthetic that corporate brands require
          </p>
        </div>

        {/* Category Navigation */}
        <div className="flex items-center justify-center mb-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {galleryCategories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`p-4 rounded-lg text-center transition-all duration-300 ${
                  selectedCategory === category.id
                    ? 'bg-accent text-white shadow-glow'
                    : 'bg-surface text-text-primary hover:bg-accent/10 hover:shadow-subtle'
                }`}
              >
                <div className={`w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3 ${
                  selectedCategory === category.id ? 'bg-white/20' : 'bg-accent/10'
                }`}>
                  <Icon 
                    name={category.icon} 
                    size={24} 
                    color={selectedCategory === category.id ? '#FFFFFF' : '#D4AF37'} 
                    strokeWidth={2} 
                  />
                </div>
                <h3 className="font-bold text-sm mb-1">{category.name}</h3>
                <p className="text-xs opacity-80 leading-tight">{category.description}</p>
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 animate-fade-in">
          {currentGallery.map((item) => (
            <div
              key={item.id}
              className="group relative overflow-hidden rounded-lg shadow-subtle hover:shadow-elevation transition-all duration-300 cursor-pointer"
              onClick={() => setLightboxImage(item)}
            >
              {/* Image */}
              <div className="relative h-64">
                <Image
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>
                
                {/* Hover Overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                    <Icon name="Eye" size={24} className="text-white" strokeWidth={2} />
                  </div>
                </div>
              </div>

              {/* Content Overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h4 className="text-white font-bold text-lg mb-1">{item.title}</h4>
                <p className="text-white/80 text-sm mb-2">{item.description}</p>
                <span className="inline-block bg-accent/80 text-white px-2 py-1 rounded text-xs font-medium">
                  {item.client}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Gallery Stats */}
        <div className="mt-16 bg-surface rounded-lg p-8">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-accent mb-2">500+</div>
              <div className="text-text-secondary">Exclusive Images</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-accent mb-2">150+</div>
              <div className="text-text-secondary">Corporate Clients</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-accent mb-2">98%</div>
              <div className="text-text-secondary">Authenticity Rating</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-accent mb-2">100%</div>
              <div className="text-text-secondary">Brand Compliance</div>
            </div>
          </div>
        </div>

        {/* Lightbox Modal */}
        {lightboxImage && (
          <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="relative max-w-4xl w-full">
              {/* Close Button */}
              <button
                onClick={() => setLightboxImage(null)}
                className="absolute -top-12 right-0 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors z-10"
              >
                <Icon name="X" size={20} strokeWidth={2} />
              </button>
              
              {/* Image */}
              <div className="relative">
                <Image
                  src={lightboxImage.image}
                  alt={lightboxImage.title}
                  className="w-full max-h-[80vh] object-contain rounded-lg"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg">
                  <h3 className="text-white font-bold text-2xl mb-2">{lightboxImage.title}</h3>
                  <p className="text-white/80 mb-2">{lightboxImage.description}</p>
                  <span className="inline-block bg-accent text-white px-3 py-1 rounded text-sm font-medium">
                    {lightboxImage.client}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default CollaborationGallery;